export default "__VITE_ASSET__$Vg$G8Qe__"